import React from 'react'
import { FormContextProvider } from '../../../../context/formContext'
import Form from './Form'
import Toast from '../../../../components/Toast/Toast'
const FormWrapper = () => {
  return (
    <FormContextProvider>
      <Form />
      <Toast />
    </FormContextProvider>
  )
}

export default FormWrapper
